import { IsNotEmpty } from "class-validator";
import { IBase, IKitchenArea } from "../../interfaces";

export class KitchenAreaDTO implements Omit<IKitchenArea, keyof IBase> {
  @IsNotEmpty({ message: 'Le nom est requis' })
  name: string;
}